import React from "react";

import BookmarkAddOutlinedIcon from "@mui/icons-material/BookmarkAddOutlined";
import LanguageIcon from "@mui/icons-material/Language";
import { Button, IconButton, Stack, Typography } from "@mui/material";
import { CommentIcon, SendIcon } from "assets/material-custom-icons";
import { useDevice } from "hooks";

import { NewsActions } from "./News";

interface Props {
  actions: NewsActions;
  onCommentClick?: () => void;
}

export const Actions: React.FC<Props> = ({ actions, onCommentClick }) => {
  const hasAnyAction =
    actions.showBookmark ||
    actions.showSend ||
    actions.showComment ||
    actions.showSeeItem ||
    (actions.commentsCount !== undefined && actions.commentsCount > 0);

  if (!hasAnyAction) {
    return null;
  }

  const { isMobile } = useDevice();

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Stack direction="row" gap="10px" alignItems="center">
        {actions.showBookmark && (
          <>
            {isMobile ? (
              <IconButton>
                <BookmarkAddOutlinedIcon sx={{ fontSize: "20px", color: "#071f35" }} />
              </IconButton>
            ) : (
              <Button
                startIcon={<BookmarkAddOutlinedIcon sx={{ fontSize: "20px", color: "#071f35" }} />}
                sx={{
                  fontSize: "16px",
                  fontWeight: 400,
                  color: "#071f35",
                  textTransform: "none",
                  minWidth: "auto",
                  px: "16px",
                  py: "4px"
                }}
              >
                Bookmark
              </Button>
            )}
          </>
        )}

        {actions.showSend && (
          <>
            {isMobile ? (
              <IconButton>
                <SendIcon sx={{ fontSize: "20px", color: "#071f35" }} />
              </IconButton>
            ) : (
              <Button
                startIcon={<SendIcon sx={{ fontSize: "20px" }} />}
                sx={{
                  fontSize: "16px",
                  fontWeight: 400,
                  color: "#071f35",
                  textTransform: "none",
                  minWidth: "auto",
                  px: "16px",
                  py: "4px"
                }}
              >
                Send
              </Button>
            )}
          </>
        )}
        {actions.showComment && (
          <>
            {isMobile ? (
              <IconButton onClick={onCommentClick}>
                <CommentIcon sx={{ fontSize: "20px", fill: "#071F35", color: "#071F35" }} />
              </IconButton>
            ) : (
              <Button
                startIcon={<CommentIcon sx={{ fontSize: "20px", fill: "#071F35", color: "#071F35" }} />}
                onClick={onCommentClick}
                sx={{
                  fontSize: "16px",
                  fontWeight: 400,
                  color: "#071f35",
                  textTransform: "none",
                  minWidth: "auto",
                  px: "16px",
                  py: "4px"
                }}
              >
                Comment
              </Button>
            )}
          </>
        )}
      </Stack>
      <Stack direction="row" gap="20px" alignItems="center">
        {actions.commentsCount !== undefined && actions.commentsCount > 0 && (
          <Typography sx={{ fontSize: "16px", color: "#496682" }}>{actions.commentsCount} comments</Typography>
        )}
        {actions.showSeeItem && (
          <>
            {isMobile ? (
              <IconButton>
                <LanguageIcon sx={{ fontSize: "20px", color: "#071f35" }} />
              </IconButton>
            ) : (
              <Button
                startIcon={<LanguageIcon sx={{ fontSize: "20px", color: "#071f35" }} />}
                sx={{
                  fontSize: "16px",
                  fontWeight: 400,
                  color: "#071f35",
                  textTransform: "none",
                  minWidth: "auto",
                  px: "16px",
                  py: "4px"
                }}
              >
                See item
              </Button>
            )}
          </>
        )}
      </Stack>
    </Stack>
  );
};
